import { Component, AfterViewInit, ViewChild, ElementRef, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

@Component({
  selector: 'app-childbox',
  templateUrl: './childbox.component.html',
  styleUrls: ['./childbox.component.css']
})
export class ChildboxComponent implements OnInit {

  childForm: FormGroup;
  replyComment: Array<object> = [];
  submitted: Boolean = false;
  @Output() userReplycomment = new EventEmitter();
  @Output() deletNo = new EventEmitter();
  @Input() queryindexno: any;
  @Input() createdby: any;
  @Input() profile_picture_url: any;
  @Input() queryid: any;
  @Input() type: any;
  @Input() query: any;

  constructor(private formBuilder: FormBuilder) { }

  ngOnInit() {
    this.createForm();   
  }

  createForm() {
    this.childForm = this.formBuilder.group({
      comment: ['', [Validators.required]]
    });
    if (this.type == 'edit')
      this.childForm.controls['comment'].setValue(this.query);
  }

  onSubmit() {
    this.submitted = true;
    if (this.childForm.invalid) {
      return false;
    }
    else {
     
      this.replyComment.push({
        queryid: this.queryid,
        createdon: new Date(),
        createdby: this.createdby,
        profile_picture_url:this.profile_picture_url,
        query: this.childForm.controls['comment'].value
      });
      
      this.userReplycomment.emit(this.replyComment);
      this.deletNo.emit(this.queryindexno);
    }
  }

  closechild() {
    this.userReplycomment.emit(this.replyComment);
    this.deletNo.emit(this.queryindexno);
  }

}
